import React, { useContext, useEffect } from 'react'
import VehicleDA_Directions from './VehicleDA_Directions'
import VehicleDA_SelectVehicle from './VehicleDA_SelectVehicle'
import ValidationModal from 'components/ValidationModal'
import { AddVehicleContext } from 'components/StraightThroughVehicleComp/AddVehicleContext/AddVehicleContext'
import VehicleKeptOvernightQuestion from './VehicleKeptOvernightQuestion'
//import { VehicleDA_StylesContext } from 'components/ChangeRequest_VehicleChangeComp/2_DriverAssignment/VehicleDA_Main'

const setEndorsementClassStr = (type) => {
  var typeObj = {
    "AddVehicle": "addVehicleClass",
    "RemoveVehicle": "removeVehicleClass",
    "ReplaceVehicle": "replaceVehicleClass",
    "AddressChange": "addressChangeClass",
    "HouseholdChange": "householdChangeClass"
  }
  return typeObj[type]
}

const VehicleDA = ({ requestContext, vehicleContext, endorsementType }) => {
  const context = useContext(requestContext)
  const vehicleClassStr = setEndorsementClassStr(endorsementType)

  const styles = {
    indent: {
      paddingLeft: "15px",
    },
    blueText: {
      color: "#046ab0",
      fontSize: '13.5px'
    }
  }

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  const setClass = () => {
    if (endorsementType == "AddVehicle") { return (context.addVehicleClass) }
    else if (endorsementType == "RemoveVehicle") { return (context.removeVehicleClass) }
    else if (endorsementType == "ReplaceVehicle") { return (context.replaceVehicleClass) }
    else if (endorsementType == "AddressChange") { return (context.addressChangeClass) }
    else if (endorsementType == "HouseholdChange") { return (context.householdChangeClass) }
  }

  return (
    <>
      <div className="row text-muted">
        <div className="col-12">
          <VehicleDA_Directions />
          <VehicleDA_SelectVehicle vehReqContext={requestContext} reqVehicleClass={vehicleClassStr} setVehicleClass={setClass} requestType={endorsementType} />

          {endorsementType == "RemoveVehicle" &&
            <>
              <hr />
              <VehicleKeptOvernightQuestion requestContext={requestContext} reqVehicleClass={vehicleClassStr} />
            </>
          }
        </div>
      </div>

      <ValidationModal
        title={context.validationTitle}
        show={context.showModal}
        handleClose={() => context.setShowModal(false)}
        validationMsg={context.validationMsg}
      />
    </>
  )
}

export default VehicleDA